<div class="mobile-app-page">
  <section class="hero-section">
    <div class="container">
      <div class="row align-items-center g-4 g-lg-5">
        <div class="col-lg-6">
          <p class="eyebrow mb-2">Mobile for your members</p>
          <h1 class="headline mt-primary-text mb-3">A modern mobile experience for every community</h1>
          <p class="subheadline mb-4">
            Give members a modern mobile experience with MemberTrace. The <strong>shared app</strong> gives your organization one place inside MemberTrace with your branding built in—no separate app build or maintenance. For a <strong>fully owned</strong> presence, Enterprise can launch a custom branded app in the App Store and Google Play with white-glove support.
          </p>
          <div class="cta-buttons">
            <button mat-flat-button color="primary" routerLink="/pricing">See pricing</button>
            <button mat-stroked-button color="primary" routerLink="/contact" [queryParams]="{ inquiryType: 'demo' }">Talk to our team</button>
            <button mat-stroked-button color="primary" routerLink="/contact" [queryParams]="{ inquiryType: 'enterprise' }">Ask about branded apps</button>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="hero-visual">
            <div class="device-frame" aria-hidden="true">
              <span class="device-notch"></span>
              <img
                class="device-app-icon"
                [src]="appIconSrc"
                alt="MemberTrace app icon"
                width="120"
                height="120"
                loading="eager" />
            </div>
            @if (iosAppStoreUrl) {
              <a
                class="app-store-link"
                [href]="iosAppStoreUrl"
                target="_blank"
                rel="noopener noreferrer"
                (click)="onAppStoreClick()">
                <img
                  src="/img/app-store-badge.svg"
                  alt="Download MemberTrace on the App Store"
                  width="120"
                  height="40"
                  loading="lazy" />
              </a>
            }
            <p class="visual-caption text-center mt-3 mb-0">
              MemberTrace on iOS · Efficient shared app for most orgs · Fully owned branded apps for Enterprise
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="paths-section py-5">
    <div class="container">
      <h2 class="section-title text-center mb-3">Two paths: shared app or your own</h2>
      <p class="section-intro text-center mb-5">
        Every plan includes your logo, colors, and a member-facing mobile experience. Most organizations start with the shared app for speed and simplicity; Enterprise adds fully branded store listings when you want a fully owned mobile presence.
      </p>
      <div class="row g-4">
        <div class="col-lg-6">
          <mat-card class="path-card h-100">
            <mat-card-content class="p-4">
              <div class="path-card-header mb-3">
                <mat-icon color="primary" class="path-icon">apps</mat-icon>
                <h3 class="path-title mb-0">Shared MemberTrace app</h3>
              </div>
              <p class="path-lead">
                Launch quickly with a member-facing mobile experience inside the MemberTrace app, with your logo and colors built in.
              </p>
              <ul class="path-list">
                <li *ngFor="let item of sharedBullets">{{ item }}</li>
              </ul>
              <button mat-flat-button color="primary" class="mt-2" routerLink="/pricing">See plans</button>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-lg-6" id="custom-branded-apps">
          <mat-card class="path-card path-card--enterprise h-100">
            <mat-card-content class="p-4">
              <div class="path-card-header mb-3">
                <mat-icon color="accent" class="path-icon">storefront</mat-icon>
                <h3 class="path-title mb-0">Custom branded apps</h3>
              </div>
              <p class="path-lead">
                Launch a fully branded app in the App Store and Google Play, with scoped white-glove support for a fully owned mobile presence.
              </p>
              <ul class="path-list">
                <li *ngFor="let item of customBullets">{{ item }}</li>
              </ul>
              <button mat-stroked-button color="primary" class="mt-2" routerLink="/contact" [queryParams]="{ inquiryType: 'enterprise' }">Ask about branded apps</button>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </section>

  <section class="faq-strip py-4">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <h2 class="section-title text-center mb-4">Questions members (and boards) ask</h2>
          <div class="row g-4">
            <div class="col-md-6">
              <div class="mini-faq">
                <h3 class="mini-faq-q">Do members need a separate app for every organization?</h3>
                <p class="mini-faq-a mb-0">No. Members use the shared MemberTrace app to access every MemberTrace-powered organization they belong to in one place, reducing friction and app fatigue.</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mini-faq">
                <h3 class="mini-faq-q">Is a custom app required?</h3>
                <p class="mini-faq-a mb-0">No. Most organizations use the shared app with full branding built in. Custom apps are optional for Enterprise teams that want standalone App Store and Google Play listings.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="cta-section py-5">
    <div class="container text-center">
      <h2 class="section-title mb-3">Ready to launch your member mobile experience?</h2>
      <p class="section-intro mb-4">Start with the shared app, or talk with us about a fully branded app for your organization.</p>
      <div class="cta-buttons justify-content-center">
        <button mat-flat-button color="primary" routerLink="/pricing">See plans</button>
        <button mat-stroked-button color="primary" routerLink="/contact" [queryParams]="{ inquiryType: 'enterprise' }">Ask about branded apps</button>
      </div>
    </div>
  </section>
</div>
